import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const EqualIcon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref}>
    <>
      <rect fill="none" height="24" width="24" />
      <path d="m5 8v2h14v-2h-14zm0 6v2h14v-2h-14z" />
    </>
  </SvgIcon>
));

export default EqualIcon;
